window.Yext = window.Yext || {};
import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';
import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/carousel.js';
import 'node_modules/sixpack-client/sixpack.js';
import 'node_modules/slick-carousel/slick/slick.js';

require('script-loader!.tmp/js/templates/location/modules/carousel.js');
require('script-loader!.tmp/js/templates/components/Secrets/Secrets.js');

import { setupSalonServicesCarousel } from 'js/carousel.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { InitSoy2JS } from 'js/components/Soy2js/Soy2js.js';
InitSoy2JS(window.Yext);

import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js'; /* TODO: remove if unused */
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js'; /* TODO: remove if unused */
import { LocationHours } from 'js/components/LocationHours/index.js'; /* TODO: remove if unused */
import { Maps } from 'js/components/Maps/Providers/index.js'; /* TODO: remove if unused */
import { Reviews } from 'js/common/modules/Reviews.js';

import { FAQ } from 'js/components/FAQ/index.js';
import { RunIfVisible } from 'js/components/RunIfVisible/index.js';
import { SalonServices } from 'js/common/modules/SalonServices';
import { SalonCategories } from 'js/common/modules/SalonCategories';

import { LocationMap, MapSetup } from 'js/search/modules/LocationMap.js';
import { GoogleMaps } from 'js/components/Maps/Providers/Google.js';
import { Description } from './components/Description';
window.Yext.Maps = { SearchMap: LocationMap };

Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');

function handleRecommendations(data) {
  if (data.resonance && data.resonance.schemes && data.resonance.schemes.length) {
    $('#js-recommendations-carousel').html(location.carousel(data.resonance.schemes[0]));
    $('#js-slick-target').on('init', function (event, slick, direction) {

      // lazy load the slick carousel content
      if (Yext.LazyLoader) {
        Yext.LazyLoader.update();
      }
    }).slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      draggable: false,
      arrows: true,
      prevArrow: '<button type="button" class="carousel-prev" data-ya-track="product_button"><i class="fa fa-angle-left carousel-directionIcon"></i></button>',
      nextArrow: '<button type="button" class="carousel-next" data-ya-track="product_button"><i class="fa fa-angle-right carousel-directionIcon"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            slidesToShow: 2.5,
            slidesToScroll: 2.5,
            swipeToSlide: true,
            arrows: false
          }
        }
      ]
    });
  }
}

function getAdobeRecommendations(entityId) {
  console.log('entityId', entityId);
  $.ajax({
    type: "Get",
    url: "https://jcpenney.tt.omtrdc.net/m2/jcpenney/ubox/raw",
    data: {
      mbox: "storelocator1_jrecs",
      'entity.categoryId': entityId,
      recommendations: "true",
      schemes: "pdpcompare1_jrecs;pdp1_jrecs;pdp2_jrecs;pdp3_jrecs;pdp4_jrecs",
      mboxContentType: "application/json",
      mboxSession: "98202d140e1d406493e0e3b97256f70b",
      mboxPC: "6e23be80fde74447b60d6b1844de6f1d.28_113",
      mboxDefault: "%7B%7D",
      mboxXDomain: "disable",
      mboxNoRedirect: "true",
      mboxHost: "www.jcpenney.com",
      mboxURL: "https%3A%2F%2Fwww.jcpenney.com%2Fp%2Fxersion-womens-performance-tee%2Fppr5007276860%3FpTmplType%3Dregular%26campaignid%3DEXAMPLECampaignID"
    },
    success: handleRecommendations,
    failure: function() {
      console.log('Error ajaxing recommendations.')
    }
  })
}

function faqJS() {
  FAQ.init();
}

function adobeRecommendations() {
  const entityId = document.querySelector('#recommendationsData');
  if (entityId) {
    getAdobeRecommendations(entityId.innerHTML);
  }
}

OnReady(() => {
  Maps.loadAndRun();
  const mapProvider = GoogleMaps;
  mapProvider.load(secrets.YextMapsKeyGoogle(), {
    autocomplete: true,
    client: secrets.YextMapsClientGoogle(),
  }).then(() => {
    window.Yext.Maps.SearchMap.providerCallback()
    MapSetup();
    handleMap('schema-location');
  });
  LocationHours.loadAndRun();
  new SalonServices();
  new SalonCategories();
  new Reviews();
  RunIfVisible.runIfTargetVisible(document.querySelector('.FAQ'), faqJS);

  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();

  RunIfVisible.runIfTargetVisible(document.querySelector('.recommendations-container'), adobeRecommendations);

  // The following code was decaffinated.

  window.instagramTemplates = {};

  window.instagramTemplates['desktop-instafeed'] = '<div class=\"c-instagram-photo-wrapper col-spaced col-sm-3 col-xs-12\"><a href=\"{{link}}\" target=_blank><img class=\"c-instagram-photo\" src=\"{{image}}\" /></a><div class=\"c-instagram-photo-info\"><i class=\"fa fa-heart\"></i><span class=\"c-instagram-photo-info-likes\">{{likes}}</span><i class=\"fa fa-comment\"></i><span class=\"c-instagram-photo-info-comments\">{{comments}}</span></div></div>';

  window.instagramTemplates['mobile-instafeed'] = '<div class=\"c-instagram-photo-wrapper col-spaced col-sm-3 col-xs-12\"><a href=\"{{link}}\" target=_blank><img class=\"c-instagram-photo\" src=\"{{image}}\" /></a><div class=\"c-instagram-photo-info\"><i class=\"fa fa-heart\"></i><span class=\"c-instagram-photo-info-likes\">{{likes}}</span><i class=\"fa fa-comment\"></i><span class=\"c-instagram-photo-info-comments\">{{comments}}</span></div></div>';

  window.instagramCallbacks = {};

  window.instagramCallbacks['instafeed'] = function() {
    return $('.instagram-row-wrapper').show();
  };

  setupSalonServicesCarousel();

  $(document).scroll(function() {
    var y;
    y = $(this).scrollTop();
    if (y > 400 && $(window).width() < 768) {
      $('.back-to-top-image').fadeIn();
    } else {
      $('.back-to-top-image').fadeOut();
    }
    if ($(window).width() > 768) {
      return $('.back-to-top-image').fadeOut();
    }
  });

  $('.store-services-item:contains("Benefit Brow Bar")').prependTo('.store-services');

  //Might need to change this
  $('.store-services-item:contains("sephora")').prependTo('.store-services');

  $(function() {
    $('a.back-to-top').click(function() {
      var target;
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
        target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html,body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  });

  let services = $('#js-LocationInfo-servicesList');
  $('#js-LocationInfo-collaspeServicesHeading').click(function() {
    services.slideToggle();
    $('.LocationInfo-collapseIcon').toggleClass('LocationInfo-collapseIcon--closed');
  });
  $('#js-LocationInfo-collaspeServices').click(function() {
    services.slideToggle();
    $('.LocationInfo-collapseIcon').toggleClass('LocationInfo-collapseIcon--closed');
  });

  const siteLinks = $('.js-site-links');
  const activeLink = siteLinks.find('.site-link.is-active');
  const containerOffset = siteLinks.offset().left;
  const linkOffset = activeLink.offset().left;
  const scroll = linkOffset - containerOffset;
  if (scroll > 0) {
    $(siteLinks).animate({
      scrollLeft: scroll
    }, 500);
  }
});
